import { Grid, Stack, Typography } from '@mui/material';
import Link from '@mui/material/Link';
import { startCase } from 'lodash';
import { useFormContext } from 'react-hook-form';

import { FormCheckbox } from '@/components/form/FormCheckbox';

/* Review
    termsAndConditions: false,
*/

const reviewFieldRows = [
    ['firstName', 'lastName'],
    ['email', 'phone'],
    ['organization'],
    ['address', 'city'],
    ['zipcode', 'state'],
    ['country'],
    ['username'],
];

export const ReviewStep = () => {
    const { control, getValues } = useFormContext();
    const values = getValues();

    return (
        <Grid container spacing={3}>
            <Grid size={{ xs: 12 }}>
                <Typography variant="h4">Did we get it right?</Typography>
            </Grid>
            {reviewFieldRows.map((row, i) => (
                <Grid key={i} container spacing={3} size={{ xs: 12 }}>
                    {row.map((fieldName, j) => (
                        <Grid key={`${i}-${j}`} size={{ xs: 12, sm: 6 }}>
                            <Stack direction="row" spacing={2} justifyContent="flex-start" alignItems="center">
                                <Typography variant="subtitle2">{startCase(fieldName)}</Typography>
                                <Typography variant="body1">{values[fieldName]}</Typography>
                            </Stack>
                        </Grid>
                    ))}
                </Grid>
            ))}

            <Grid container spacing={3}>
                <Grid size={{ xs: 12 }}>
                    <FormCheckbox
                        name="termsAndConditions"
                        control={control}
                        label={
                            <Typography variant="body2">
                                I agree to adhere to Sofar Ocean Technologies&apos;{' '}
                                <Link href="https://www.sofarocean.com/legal/privacy-policy">Privacy policy</Link> and{' '}
                                <Link href="https://www.sofarocean.com/legal/terms-of-use">Terms of use</Link>
                            </Typography>
                        }
                        formControlLabelProps={{ sx: { '&:has(.MuiCheckbox-root)': { alignItems: 'center' } } }}
                        checkboxProps={{
                            size: 'medium',
                            id: 'termsAndConditions',
                        }}
                        controllerProps={{
                            rules: {
                                required: 'Terms and Conditions must be accepted',
                            },
                        }}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};
